import { Box, Text } from "@chakra-ui/react";
import { AppLink, RichText } from "@/components";
import { BACK_LINK } from "@/content";

export const BackLink = () => (
  <Box as="section" className="print-hide" maxW="860px" mx="auto" px="pad" pb="sec">
    <AppLink
      href={BACK_LINK.href}
      data-group
      display="flex"
      alignItems="center"
      gap="18px"
      px="clamp(20px, 2.6vw, 32px)"
      py="clamp(20px, 2.4vw, 28px)"
      borderRadius="md"
      border="1px solid"
      borderColor="line.hairline"
      transitionProperty="background-color, border-color"
      transitionDuration="0.25s"
      transitionTimingFunction="brand"
      _hover={{ bg: "surface.white", borderColor: "rgba(247, 95, 45, 0.45)" }}
    >
      <Box
        aria-hidden="true"
        w="34px"
        h="34px"
        flexShrink={0}
        display="grid"
        placeItems="center"
        borderRadius="50%"
        bg="ink.DEFAULT"
        color="ink.light"
        fontSize="0.9rem"
        transitionProperty="background-color, transform"
        transitionDuration="0.3s"
        transitionTimingFunction="brand"
        _groupHover={{ bg: "brand.500", transform: "translateX(-3px)" }}
      >
        ←
      </Box>
      <Box>
        <Text
          as="strong"
          display="block"
          fontWeight="light"
          fontSize="clamp(1.0625rem, 1.35vw, 1.375rem)"
          lineHeight={1}
          textTransform="uppercase"
        >
          <RichText nodes={BACK_LINK.title} />
        </Text>
        <Text as="small" display="block" mt="6px" fontSize="small" color="warm.600">
          {BACK_LINK.note}
        </Text>
      </Box>
    </AppLink>
  </Box>
);
